import DeleteTicket from "./DeleteTicket";

export default DeleteTicket